import { render, staticRenderFns } from "./StepperButtons.vue?vue&type=template&id=4f2c700a&scoped=true&"
import script from "./StepperButtons.vue?vue&type=script&lang=js&"
export * from "./StepperButtons.vue?vue&type=script&lang=js&"
import style0 from "./StepperButtons.vue?vue&type=style&index=0&id=4f2c700a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c700a",
  null
  
)

export default component.exports